(function () {
  'use strict';

  /*
   * ============================================================
   * WISHLIST HERO - CUSTOM INTEGRATION
   * ============================================================
   *
   * Handles:
   * - Header wishlist button
   * - Header wishlist count
   * - Generic wishlist buttons
   * - Product card wishlist buttons
   * - PDP wishlist button
   * - PDP variant changes
   * - Add / remove wishlist items
   * - Wishlist Hero SDK events
   *
   * ============================================================
   */

  const Wishlist = {

    sdk: null,
    ready: false,
    toastTimer: null,

    showToast: function (message) {

  let toast =
    document.getElementById(
      'wishlist-toast'
    );

  if (!toast) {

    toast =
      document.createElement('div');

    toast.id =
      'wishlist-toast';

    toast.className =
      'wishlist-toast';

    toast.setAttribute(
      'role',
      'status'
    );

    toast.setAttribute(
      'aria-live',
      'polite'
    );

    document.body.appendChild(
      toast
    );
  }

  toast.textContent = message;

  toast.classList.add(
    'is-visible'
  );

  clearTimeout(
    this.toastTimer
  );

  this.toastTimer =
    setTimeout(
      function () {

        toast.classList.remove(
          'is-visible'
        );

      },
      2500
    );
},
    /*
     * ============================================================
     * INITIALIZATION
     * ============================================================
     */

    init: function () {

      /*
       * SDK already loaded
       */
      if (window.WishListHero_SDK) {
        this.setSDK();
      }

      /*
       * SDK loads asynchronously
       */
      document.addEventListener(
        'wishlist-hero-wishlist-sdk-ready',
        function () {
          Wishlist.setSDK();
        }
      );

      /*
       * Wishlist changed somewhere else
       */
      document.addEventListener(
        'wishlist-hero-wishlist-updated',
        function () {
          Wishlist.refreshAll();
        }
      );
    },


    /*
     * ============================================================
     * SET SDK
     * ============================================================
     */

    setSDK: function () {

      if (!window.WishListHero_SDK) {
        console.warn(
          'Wishlist Hero SDK is not available.'
        );

        return;
      }

      this.sdk = window.WishListHero_SDK;
      this.ready = true;

      console.log(
        'Wishlist Hero SDK ready.'
      );

      this.initialize();
    },


    /*
     * ============================================================
     * MAIN INITIALIZATION
     * ============================================================
     */

    initialize: function () {

      if (
        !this.ready ||
        !this.sdk
      ) {
        return;
      }

      /*
       * Header wishlist
       */
      this.initializeHeader();

      /*
       * Existing generic wishlist buttons
       */
      this.initializeWishlistButtons();

      /*
       * Product card wishlist buttons
       */
      this.initializeCardWishlistButtons();

      /*
       * PDP wishlist
       */
      this.initializePDP();

      /*
       * Initial state
       */
      this.refreshAll();
    },


    /*
     * ============================================================
     * GET WISHLIST ITEMS
     * ============================================================
     */

    getWishlistItems: function () {

      if (
        !this.ready ||
        !this.sdk ||
        typeof this.sdk.GetWishListItems !==
          'function'
      ) {
        return [];
      }

      try {

        const items =
          this.sdk.GetWishListItems();

        return Array.isArray(items)
          ? items
          : [];

      } catch (error) {

        console.error(
          'Wishlist Hero: Unable to get wishlist items.',
          error
        );

        return [];
      }
    },


    /*
     * ============================================================
     * GET WISHLIST COUNT
     * ============================================================
     */

    getWishlistCount: function () {

      if (
        !this.ready ||
        !this.sdk
      ) {
        return 0;
      }

      /*
       * Use SDK count method if available.
       */
      if (
        typeof this.sdk.GetWishListItemsCount ===
        'function'
      ) {

        try {

          const count =
            this.sdk.GetWishListItemsCount();

          if (
            typeof count === 'number' &&
            !isNaN(count)
          ) {
            return count;
          }

        } catch (error) {

          console.warn(
            'Wishlist Hero: GetWishListItemsCount failed.',
            error
          );
        }
      }

      /*
       * Fallback
       */
      return this.getWishlistItems().length;
    },


    /*
     * ============================================================
     * GET WISHLIST HASH
     * ============================================================
     */

    getWishlistHash: async function (
      createIfMissing
    ) {

      if (
        !this.ready ||
        !this.sdk ||
        typeof this.sdk.GetWishListHash !==
          'function'
      ) {
        return null;
      }

      try {

        return await this.sdk.GetWishListHash(
          createIfMissing
        );

      } catch (error) {

        console.error(
          'Wishlist Hero: Unable to get WishlistHash.',
          error
        );

        return null;
      }
    },


    /*
     * ============================================================
     * CHECK IF VARIANT IS WISHLISTED
     * ============================================================
     */

    isVariantWishlisted: function (
      variantId
    ) {

      if (!variantId) {
        return false;
      }

      const items =
        this.getWishlistItems();

      return items.some(
        function (item) {

          const itemVariantId =
            item.ProductVariantId ||
            item.productVariantId ||
            '';

          return (
            String(itemVariantId) ===
            String(variantId)
          );
        }
      );
    },


    /*
     * ============================================================
     * HEADER WISHLIST
     * ============================================================
     */

    initializeHeader: function () {

      const buttons =
        document.querySelectorAll(
          '[data-wishlist-open]'
        );

      if (!buttons.length) {
        return;
      }

      buttons.forEach(
        function (button) {

          if (
            button.dataset
              .wishlistBound ===
            'true'
          ) {
            return;
          }

          button.dataset
            .wishlistBound =
            'true';

          button.addEventListener(
            'click',
            function () {

              if (
                !Wishlist.ready ||
                !Wishlist.sdk
              ) {

                console.warn(
                  'Wishlist Hero SDK is not ready.'
                );

                return;
              }

              if (
                typeof Wishlist.sdk
                  .OpenWishList ===
                'function'
              ) {

                Wishlist.sdk.OpenWishList();

              }

            }
          );

        }
      );
    },


    /*
     * ============================================================
     * UPDATE HEADER WISHLIST COUNT
     * ============================================================
     */

    updateWishlistCount: function () {

      if (
        !this.ready ||
        !this.sdk
      ) {
        return;
      }

      /*
       * ONLY select the count span.
       */
      const countElements =
        document.querySelectorAll(
          '.header-wishlist-count'
        );

      if (!countElements.length) {
        return;
      }

      const count =
        this.getWishlistCount();

      countElements.forEach(
        function (element) {

          element.textContent =
            String(count);

        }
      );

      console.log(
        'Wishlist count updated:',
        count
      );
    },


    /*
     * ============================================================
     * EXISTING GENERIC WISHLIST BUTTONS
     * ============================================================
     */

    initializeWishlistButtons: function () {

      const containers =
        document.querySelectorAll(
          '[data-wishlist-button]'
        );

      containers.forEach(
        function (container) {

          Wishlist.initializeWishlistButton(
            container
          );

        }
      );
    },


    /*
     * ============================================================
     * INITIALIZE EXISTING GENERIC BUTTON
     * ============================================================
     */

    initializeWishlistButton:
      function (container) {

        if (
          container.dataset
            .wishlistInitialized ===
          'true'
        ) {
          return;
        }

        const button =
          container.querySelector(
            '.custom-wishlist-button__trigger'
          );

        if (!button) {
          return;
        }

        container.dataset
          .wishlistInitialized =
          'true';

        button.addEventListener(
          'click',
          function () {

            Wishlist.toggleWishlistButton(
              container
            );

          }
        );

        this.refreshWishlistButton(
          container
        );
      },


    /*
     * ============================================================
     * GET GENERIC PRODUCT DATA
     * ============================================================
     */

    getGenericProductData:
      function (container) {

        return {

          ProductId:
            String(
              container.dataset
                .productId || ''
            ),

          ProductVariantId:
            String(
              container.dataset
                .variantId || ''
            ),

          ProductTitle:
            container.dataset
              .productTitle || '',

          ProductPrice:
            parseFloat(
              container.dataset
                .productPrice || '0'
            ),

          ProductLink:
            container.dataset
              .productLink || '',

          ProductImage:
            container.dataset
              .productImage || ''
        };
      },


    /*
     * ============================================================
     * TOGGLE GENERIC WISHLIST BUTTON
     * ============================================================
     */

    toggleWishlistButton:
      async function (container) {

        if (
          !this.ready ||
          !this.sdk
        ) {

          console.warn(
            'Wishlist Hero SDK is not ready.'
          );

          return;
        }

        const button =
          container.querySelector(
            '.custom-wishlist-button__trigger'
          );

        if (!button) {
          return;
        }

        const product =
          this.getGenericProductData(
            container
          );

        if (
          !product.ProductId ||
          !product.ProductVariantId
        ) {

          console.error(
            'Wishlist Hero: Missing product or variant information.',
            product
          );

          return;
        }

        const isActive =
          container.dataset
            .wishlistActive ===
          'true';

        try {

          button.disabled = true;

          if (isActive) {

            await this.removeItem(
              product
            );

          } else {

            await this.addItem(
              product
            );
          }

          this.refreshWishlistButton(
            container
          );

          this.updateWishlistCount();

        } catch (error) {

          console.error(
            'Wishlist Hero error:',
            error
          );

        } finally {

          button.disabled = false;

        }
      },


    /*
     * ============================================================
     * ADD ITEM
     * ============================================================
     */

    addItem: async function (
      product
    ) {

      if (
        !this.sdk ||
        typeof this.sdk.AddWishListItem !==
          'function'
      ) {

        console.error(
          'Wishlist Hero: AddWishListItem is not available.'
        );

        return null;
      }

      const wishlistHash =
        await this.getWishlistHash(
          true
        );

      if (!wishlistHash) {

        console.error(
          'Wishlist Hero: Unable to get WishlistHash.'
        );

        return null;
      }

      const addData = {

        WishlistHash:
          wishlistHash,

        ProductId:
          product.ProductId,

        ProductVariantId:
          product.ProductVariantId,

        ProductTitle:
          product.ProductTitle,

        ProductPrice:
          product.ProductPrice,

        ProductLink:
          product.ProductLink,

        ProductImage:
          product.ProductImage
      };

      console.log(
        'Wishlist Hero Add Data:',
        addData
      );

      const result =
        await this.sdk.AddWishListItem(
          addData
        );

      console.log(
        'Wishlist Hero add result:',
        result
      );

      if (
        !result ||
        result.ok === false
      ) {

        console.error(
          'Wishlist Hero: Add failed.',
          result
        );

        return null;
      }

      return result;
    },


    /*
     * ============================================================
     * REMOVE ITEM
     * ============================================================
     */

    removeItem: async function (
      product
    ) {

      if (
        !this.sdk ||
        typeof this.sdk.DeleteWishListItem !==
          'function'
      ) {

        console.error(
          'Wishlist Hero: DeleteWishListItem is not available.'
        );

        return null;
      }

      const wishlistHash =
        await this.getWishlistHash(
          false
        );

      if (!wishlistHash) {

        console.warn(
          'Wishlist Hero: Wishlist hash not found.'
        );

        return null;
      }

      const removeData = {

        WishlistHash:
          wishlistHash,

        ProductVariantId:
          product.ProductVariantId
      };

      console.log(
        'Wishlist Hero Remove Data:',
        removeData
      );

      const result =
        await this.sdk.DeleteWishListItem(
          removeData
        );

      console.log(
        'Wishlist Hero remove result:',
        result
      );

      if (
        !result ||
        result.ok === false
      ) {

        console.error(
          'Wishlist Hero: Remove failed.',
          result
        );

        return null;
      }

      return result;
    },


    /*
     * ============================================================
     * REFRESH GENERIC WISHLIST BUTTON
     * ============================================================
     */

    refreshWishlistButton:
      function (container) {

        if (
          !this.ready ||
          !this.sdk
        ) {
          return;
        }

        const product =
          this.getGenericProductData(
            container
          );

        if (!product.ProductVariantId) {
          return;
        }

        const exists =
          this.isVariantWishlisted(
            product.ProductVariantId
          );

        container.dataset
          .wishlistActive =
          exists
            ? 'true'
            : 'false';

        const button =
          container.querySelector(
            '.custom-wishlist-button__trigger'
          );

        const icon =
          container.querySelector(
            '.custom-wishlist-button__icon'
          );

        if (!button) {
          return;
        }

        button.setAttribute(
          'aria-pressed',
          exists
            ? 'true'
            : 'false'
        );

        button.setAttribute(
          'aria-label',
          exists
            ? 'Remove from wishlist'
            : 'Add to wishlist'
        );

        container.classList.toggle(
          'is-wishlisted',
          exists
        );

        if (icon) {

          icon.textContent =
            exists
              ? '♥'
              : '♡';

        }
      },


    /*
     * ============================================================
     * REFRESH ALL GENERIC BUTTONS
     * ============================================================
     */

    refreshAllWishlistButtons:
      function () {

        document
          .querySelectorAll(
            '[data-wishlist-button]'
          )
          .forEach(
            function (container) {

              Wishlist.refreshWishlistButton(
                container
              );

            }
          );
      },


    /*
     * ============================================================
     * ============================================================
     * PRODUCT CARD WISHLIST
     * ============================================================
     * ============================================================
     *
     * Supports:
     *
     * <button
     *   class="cardWish"
     *   data-wishlist-card
     *   data-product-id="..."
     *   data-variant-id="..."
     *   ...
     * >
     *
     * No wrapper is required.
     *
     * ============================================================
     */


    /*
     * ============================================================
     * INITIALIZE PRODUCT CARD BUTTONS
     * ============================================================
     */

    initializeCardWishlistButtons:
      function () {

        const buttons =
          document.querySelectorAll(
            '.cardWish[data-wishlist-card]'
          );

        buttons.forEach(
          function (button) {

            Wishlist.initializeCardWishlistButton(
              button
            );

          }
        );
      },


    /*
     * ============================================================
     * INITIALIZE SINGLE PRODUCT CARD BUTTON
     * ============================================================
     */

    initializeCardWishlistButton:
      function (button) {

        if (
          button.dataset
            .wishlistCardInitialized ===
          'true'
        ) {
          return;
        }

        button.dataset
          .wishlistCardInitialized =
          'true';


        /*
         * Click handler
         */
        button.addEventListener(
          'click',
          function (event) {

            event.preventDefault();
            event.stopPropagation();

            Wishlist.toggleCardWishlist(
              button
            );

          }
        );


        /*
         * Initial heart state
         */
        this.refreshCardWishlistButton(
          button
        );
      },


    /*
     * ============================================================
     * GET PRODUCT CARD DATA
     * ============================================================
     */

    getCardProductData:
      function (button) {

        return {

          ProductId:
            String(
              button.dataset
                .productId || ''
            ),

          ProductVariantId:
            String(
              button.dataset
                .variantId || ''
            ),

          ProductTitle:
            button.dataset
              .productTitle || '',

          ProductPrice:
            parseFloat(
              button.dataset
                .productPrice || '0'
            ),

          ProductLink:
            button.dataset
              .productLink || '',

          ProductImage:
            button.dataset
              .productImage || ''
        };
      },


    /*
     * ============================================================
     * TOGGLE PRODUCT CARD WISHLIST
     * ============================================================
     */

    toggleCardWishlist:
      async function (button) {

        if (
          !this.ready ||
          !this.sdk
        ) {

          console.warn(
            'Wishlist Hero SDK is not ready.'
          );

          return;
        }


        /*
         * Prevent double click while
         * request is processing.
         */
        if (
          button.dataset
            .wishlistProcessing ===
          'true'
        ) {
          return;
        }


        const product =
          this.getCardProductData(
            button
          );


        /*
         * Validate data
         */
        if (
          !product.ProductId ||
          !product.ProductVariantId
        ) {

          console.error(
            'Wishlist Hero: Product card is missing product or variant information.',
            product
          );

          return;
        }


        try {

          button.dataset
            .wishlistProcessing =
            'true';

          button.disabled = true;


          /*
           * Always check the actual SDK wishlist.
           *
           * This prevents incorrect state if
           * the item was added from another
           * button/location.
           */
          const isWishlisted =
            this.isVariantWishlisted(
              product.ProductVariantId
            );


          /*
           * REMOVE
           */
          if (isWishlisted) {

            const result =
              await this.removeItem(
                product
              );

            if (!result) {
              return;
            }

              this.showToast(
    'Product removed from wishlist'
  );

          }


          /*
           * ADD
           */
          else {

            const result =
              await this.addItem(
                product
              );

            if (!result) {
              return;
            }
              this.showToast(
    'Product added to wishlist'
  );
          }


          /*
           * Refresh this card immediately.
           */
          this.refreshCardWishlistButton(
            button
          );


          /*
           * Refresh all other wishlist
           * buttons as well.
           *
           * This is useful if the same
           * product exists more than once
           * on the page.
           */
          this.refreshAllWishlistButtons();
          this.refreshAllCardWishlistButtons();


          /*
           * Update ONLY the header count.
           */
          this.updateWishlistCount();

        } catch (error) {

          console.error(
            'Wishlist Hero Product Card error:',
            error
          );

        } finally {

          button.disabled = false;

          delete button.dataset
            .wishlistProcessing;
        }
      },


    /*
     * ============================================================
     * REFRESH SINGLE PRODUCT CARD BUTTON
     * ============================================================
     */

    refreshCardWishlistButton:
      function (button) {

        if (
          !this.ready ||
          !this.sdk
        ) {
          return;
        }


        const variantId =
          button.dataset
            .variantId || '';


        if (!variantId) {
          return;
        }


        const exists =
          this.isVariantWishlisted(
            variantId
          );


        /*
         * Store state on the button.
         */
        button.dataset
          .wishlistActive =
          exists
            ? 'true'
            : 'false';


        /*
         * Accessibility state.
         */
        button.setAttribute(
          'aria-pressed',
          exists
            ? 'true'
            : 'false'
        );


        button.setAttribute(
          'aria-label',
          exists
            ? 'Remove from wishlist'
            : 'Add ' +
              (
                button.dataset
                  .productTitle ||
                'product'
              ) +
              ' to wishlist'
        );


        /*
         * Add/remove visual state.
         *
         * This gives you:
         *
         * .cardWish.is-wishlisted
         *
         * when the item is in wishlist.
         */
        button.classList.toggle(
          'is-wishlisted',
          exists
        );


        /*
         * IMPORTANT:
         *
         * Your SVG remains completely untouched.
         *
         * We only change the class on
         * the button.
         *
         * You can style the SVG/path with CSS
         * using .is-wishlisted.
         */
      },


    /*
     * ============================================================
     * REFRESH ALL PRODUCT CARD BUTTONS
     * ============================================================
     */

    refreshAllCardWishlistButtons:
      function () {

        document
          .querySelectorAll(
            '.cardWish[data-wishlist-card]'
          )
          .forEach(
            function (button) {

              Wishlist.refreshCardWishlistButton(
                button
              );

            }
          );
      },


    /*
     * ============================================================
     * PDP HELPERS
     * ============================================================
     */

    getPdpWishlistButton:
      function () {

        return document.querySelector(
          '.pdp-add-wishlist'
        );
      },


    getVariantInput:
      function () {

        return document.querySelector(
          '.product-variant-id'
        );
      },


    getProductInput:
      function () {

        return document.querySelector(
          '.product-id'
        );
      },


    getCurrentVariantId:
      function () {

        const variantInput =
          this.getVariantInput();

        if (
          !variantInput ||
          !variantInput.value
        ) {

          return null;
        }

        return String(
          variantInput.value
        );
      },


    getCurrentProductId:
      function () {

        const productInput =
          this.getProductInput();

        if (
          !productInput ||
          !productInput.value
        ) {

          return null;
        }

        return String(
          productInput.value
        );
      },


    /*
     * ============================================================
     * GET PDP PRODUCT DATA
     * ============================================================
     */

    getPdpProductData:
      function () {

        const productInput =
          this.getProductInput();

        const variantInput =
          this.getVariantInput();

        if (
          !productInput ||
          !productInput.value
        ) {

          console.warn(
            'Wishlist Hero: Product ID not found.'
          );

          return null;
        }

        if (
          !variantInput ||
          !variantInput.value
        ) {

          console.warn(
            'Wishlist Hero: Variant ID not found.'
          );

          return null;
        }

        const productId =
          String(
            productInput.value
          );

        const variantId =
          String(
            variantInput.value
          );


        /*
         * Get Shopify product JSON.
         */
        const productDataElement =
          document.getElementById(
            'WishlistHeroProductData'
          );

        if (!productDataElement) {

          console.warn(
            'Wishlist Hero: Product JSON not found.'
          );

          return null;
        }

        let productData;

        try {

          productData =
            JSON.parse(
              productDataElement.textContent
            );

        } catch (error) {

          console.error(
            'Wishlist Hero: Could not parse product JSON.',
            error
          );

          return null;
        }


        if (
          !productData ||
          !Array.isArray(
            productData.variants
          )
        ) {

          console.warn(
            'Wishlist Hero: Product variants not found.'
          );

          return null;
        }


        /*
         * Find selected variant.
         */
        const selectedVariant =
          productData.variants.find(
            function (variant) {

              return (
                String(variant.id) ===
                variantId
              );

            }
          );


        if (!selectedVariant) {

          console.warn(
            'Wishlist Hero: Selected variant not found.',
            variantId
          );

          return null;
        }


        /*
         * Get variant image.
         */
        let variantImage = '';

        if (
          selectedVariant
            .featured_image &&
          selectedVariant
            .featured_image.src
        ) {

          variantImage =
            selectedVariant
              .featured_image
              .src;

        } else if (
          selectedVariant.image
        ) {

          variantImage =
            selectedVariant.image;

        } else if (
          productData.featured_image
        ) {

          variantImage =
            productData.featured_image;
        }


        /*
         * Shopify price is in cents.
         */
        const variantPrice =
          Number(
            selectedVariant.price
          ) / 100;


        return {

          ProductId:
            productId,

          ProductVariantId:
            variantId,

          ProductTitle:
            productData.title ||
            document.title,

          ProductPrice:
            variantPrice,

          ProductLink:
            productData.url ||
            window.location.pathname,

          ProductImage:
            variantImage
        };
      },


    /*
     * ============================================================
     * UPDATE PDP BUTTON
     * ============================================================
     */

    updatePdpWishlistButton:
      function (exists) {

        const button =
          this.getPdpWishlistButton();

        if (!button) {
          return;
        }

        button.setAttribute(
          'aria-pressed',
          exists
            ? 'true'
            : 'false'
        );

        button.setAttribute(
          'aria-label',
          exists
            ? 'Remove from wishlist'
            : 'Add to wishlist'
        );

        button.classList.toggle(
          'is-wishlisted',
          exists
        );
      },


    /*
     * ============================================================
     * REFRESH PDP WISHLIST STATE
     * ============================================================
     */

    refreshPdpWishlistState:
      function () {

        const button =
          this.getPdpWishlistButton();

        if (
          !button ||
          !this.ready ||
          !this.sdk
        ) {
          return;
        }

        const variantId =
          this.getCurrentVariantId();

        if (!variantId) {

          this.updatePdpWishlistButton(
            false
          );

          return;
        }

        const exists =
          this.isVariantWishlisted(
            variantId
          );

        this.updatePdpWishlistButton(
          exists
        );
      },


    /*
     * ============================================================
     * PDP ADD / REMOVE
     * ============================================================
     */

    togglePdpWishlist:
      async function () {

        const button =
          this.getPdpWishlistButton();

        if (
          !button ||
          !this.ready ||
          !this.sdk
        ) {
          return;
        }

        const product =
          this.getPdpProductData();

        if (!product) {
          return;
        }


        try {

          button.disabled = true;


          /*
           * Always check actual wishlist state.
           */
          const isWishlisted =
            this.isVariantWishlisted(
              product.ProductVariantId
            );


          /*
           * ADD
           */
          if (!isWishlisted) {

            const result =
              await this.addItem(
                product
              );

            if (!result) {
              return;
            }
              this.showToast(
    'Product added to wishlist'
  );
          }


          /*
           * REMOVE
           */
          else {

            const result =
              await this.removeItem(
                product
              );

            if (!result) {
              return;
            }
              this.showToast(
    'Product removed from wishlist'
  );
          }


          /*
           * Refresh PDP heart.
           */
          this.refreshPdpWishlistState();


          /*
           * Refresh collection cards
           * if the same product exists
           * on the page.
           */
          this.refreshAllCardWishlistButtons();


          /*
           * Refresh existing generic buttons.
           */
          this.refreshAllWishlistButtons();


          /*
           * Update ONLY header count.
           */
          this.updateWishlistCount();


        } catch (error) {

          console.error(
            'Wishlist Hero PDP error:',
            error
          );

        } finally {

          button.disabled = false;

        }
      },


    /*
     * ============================================================
     * WATCH VARIANT CHANGES
     * ============================================================
     */

    watchVariantChanges:
      function () {

        const variantInput =
          this.getVariantInput();

        if (!variantInput) {
          return;
        }

        if (
          variantInput.dataset
            .wishlistVariantWatcher ===
          'true'
        ) {

          return;
        }

        variantInput.dataset
          .wishlistVariantWatcher =
          'true';


        let lastVariantId =
          variantInput.value;


        /*
         * MutationObserver.
         */
        const observer =
          new MutationObserver(
            function () {

              const newVariantId =
                variantInput.value;

              if (
                newVariantId !==
                lastVariantId
              ) {

                lastVariantId =
                  newVariantId;

                Wishlist
                  .refreshPdpWishlistState();
              }

            }
          );


        observer.observe(
          variantInput,
          {
            attributes: true,
            attributeFilter: [
              'value'
            ]
          }
        );


        /*
         * Shopify themes may change
         * the value property directly.
         */
        setInterval(
          function () {

            const currentVariantId =
              variantInput.value;

            if (
              currentVariantId !==
              lastVariantId
            ) {

              lastVariantId =
                currentVariantId;

              Wishlist
                .refreshPdpWishlistState();
            }

          },
          250
        );
      },


    /*
     * ============================================================
     * INITIALIZE PDP
     * ============================================================
     */

    initializePDP:
      function () {

        const button =
          this.getPdpWishlistButton();

        if (!button) {
          return;
        }

        if (
          button.dataset
            .wishlistInitialized ===
          'true'
        ) {

          return;
        }

        button.dataset
          .wishlistInitialized =
          'true';


        button.addEventListener(
          'click',
          function () {

            Wishlist.togglePdpWishlist();

          }
        );


        /*
         * Initial PDP state.
         */
        this.refreshPdpWishlistState();


        /*
         * Watch variant changes.
         */
        this.watchVariantChanges();
      },


    /*
     * ============================================================
     * REFRESH EVERYTHING
     * ============================================================
     */

    refreshAll:
      function () {

        if (
          !this.ready ||
          !this.sdk
        ) {
          return;
        }


        /*
         * Existing generic buttons.
         */
        this.refreshAllWishlistButtons();


        /*
         * Product card buttons.
         */
        this.refreshAllCardWishlistButtons();


        /*
         * PDP wishlist state.
         */
        this.refreshPdpWishlistState();


        /*
         * Header count.
         *
         * ONLY:
         * .header-wishlist-count
         */
        this.updateWishlistCount();
      }
  };


  /*
   * ============================================================
   * EXPOSE GLOBALLY
   * ============================================================
   */

  window.WishlistHeroCustom =
    Wishlist;


  /*
   * ============================================================
   * START
   * ============================================================
   */

  Wishlist.init();


  /*
   * ============================================================
   * HANDLE DYNAMICALLY LOADED PRODUCT CARDS
   * ============================================================
   *
   * Useful for:
   * - AJAX collection filtering
   * - Infinite scroll
   * - Predictive/search results
   * - Shopify section rendering
   * - Collection pagination without full reload
   *
   * ============================================================
   */

  const wishlistCardObserver =
    new MutationObserver(
      function (mutations) {

        let foundNewCard = false;

        mutations.forEach(
          function (mutation) {

            mutation.addedNodes.forEach(
              function (node) {

                if (
                  node.nodeType !==
                  1
                ) {
                  return;
                }

                if (
                  node.matches &&
                  node.matches(
                    '.cardWish[data-wishlist-card]'
                  )
                ) {

                  foundNewCard = true;

                  if (
                    Wishlist.ready
                  ) {

                    Wishlist
                      .initializeCardWishlistButton(
                        node
                      );

                  }
                }


                if (
                  node.querySelectorAll
                ) {

                  const cards =
                    node.querySelectorAll(
                      '.cardWish[data-wishlist-card]'
                    );

                  if (cards.length) {

                    foundNewCard = true;

                    if (
                      Wishlist.ready
                    ) {

                      cards.forEach(
                        function (button) {

                          Wishlist
                            .initializeCardWishlistButton(
                              button
                            );

                        }
                      );

                    }
                  }
                }

              }
            );

          }
        );


        /*
         * Refresh newly added cards
         * against the current wishlist.
         */
        if (
          foundNewCard &&
          Wishlist.ready
        ) {

          Wishlist
            .refreshAllCardWishlistButtons();

        }
      }
    );


  wishlistCardObserver.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


})();